import { application } from './application.js'

import OpenedModalController from './opened_modal_controller.js';

application.register('opened-modal', OpenedModalController);
